export default __webpack_public_path__ + "static/media/1492509318_reminders_ios7_ios_7.55baf6b0.png";